const InfoBox = ({ label, value }) => {
  let display = value;
  if (display === null || display === undefined || display === "") {
    display = "NA";
  } else if (Array.isArray(display)) {
    display = display.join(", ");
  } else if (typeof display === "object") {
    try { display = JSON.stringify(display); } catch { display = "[Object]"; }
  }

  return (
    <div className="flex flex-col gap-1">
      <label className="text-sm font-medium text-gray-500">
        {label}
      </label>
      <input
        type="text"
        readOnly
        value={display}
        className="w-full px-3 py-2 text-sm text-gray-800 bg-gray-100 border border-gray-300 rounded-md cursor-default focus:outline-none focus:ring-1 focus:ring-gray-300"
      />
    </div>
  );
};

export default InfoBox